import apiFunctions from "./functions.js"
import api from "./api.js"


export const getMonedas = () => {
    return new Promise(resolve => {
        apiFunctions.get(api.monedas.monedas, null, null, null, (response) => {
            if (response && response.data) {
                resolve(response.data);
            }
        });
    });
};

export const patchCuotasVentasActualizarValores = (requestBody) => {
    return new Promise(resolve => {
        apiFunctions.patch(api.ventas.actualizarValores, null, requestBody, (response) => {
            if (response && response.data) {
                resolve(response.data);
            }
        });
    });
};

export const patchCuotasServiciosActualizarValores = (requestBody) => {
    return new Promise(resolve => {
        apiFunctions.patch(api.servicios.actualizarValores, null, requestBody, (response) => {
            if (response && response.data) {
                resolve(response.data);
            }
        });
    });
};

export const patchCuotasEscriturasActualizarValores = (requestBody) => {
    return new Promise(resolve => {
        apiFunctions.patch(api.escrituras.actualizarValores, null, requestBody, (response) => {
            if (response && response.data) {
                resolve(response.data);
            }
        });
    });
};

export const patchCuotasVentasAjustarDesactualizadas = (requestBody) => {
    return new Promise(resolve => {
        apiFunctions.patch(api.ventas.ajustarDesactualizadas, null, requestBody, (response) => {
            if (response && response.data) {
                resolve(response.data);
            }
        });
    });
};

export const patchCuotasServiciosAjustarDesactualizadas = (requestBody) => {
    return new Promise(resolve => {
        apiFunctions.patch(api.servicios.ajustarDesactualizadas, null, requestBody, (response) => {
            if (response && response.data) {
                resolve(response.data);
            }
        });
    });
};

export const patchCuotasEscriturasAjustarDesactualizadas = (requestBody) => {
    return new Promise(resolve => {
        apiFunctions.patch(api.escrituras.ajustarDesactualizadas, null, requestBody, (response) => {
            if (response && response.data) {
                resolve(response.data);
            }
        });
    });
};



// WEBPACK FOOTER //
// ./src/api/apicalls.js